import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Sidebar from "../../SideComponents/BlogsSidebar";
import Styles from "../../../assets/css/Blogs/ProblemSolving/ECommerceSolutions.module.css";
import debounce from "lodash.debounce"; // lodash.debounce , It will Add delay to observer that can help stoping the flickerings
import { Helmet } from "react-helmet-async";

// Global States imports
import { useGlobalState } from "../../../Functions/GlobalStates";

const ECommerceSolutions = () => {
  // This Id Will Help Get Likes & Views Of This Problem⬇️
  const questionId = "5"; // Replace with dynamic question ID
  const [likes, setLikes] = useState(0); // State to hold the number of likes
  const [Views, setViews] = useState(0); // State to hold the number of likes
  // Global States
  const { PagesWidthHeight, setPagesWidthHeight } = useGlobalState();
  // React useRef Refferences
  const CheckECommerceSolutionsSize = useRef(false);

  // Fetching images
  // const ECommerceSolutionsSolutionImages = require.context(
  //   "../../../assets/images/Blogs/ECommerceSolutions", // Path to the directory
  //   false, // Do not include subdirectories (set to true if you want to include them)
  //   /\.(png|PNG|jpg|jpeg|webp|svg)$/ // Regular expression to match file types
  // );
  // const SolutionImages = [
  // ECommerceSolutionsSolutionImages("./screen1.png"), // Dynamically load the image
  // ECommerceSolutionsSolutionImages("./screen2.png"), // Dynamically load the image
  // ECommerceSolutionsSolutionImages("./screen3.png"), // Dynamically load the image
  // ECommerceSolutionsSolutionImages("./screen4.png"), // Dynamically load the image
  // ECommerceSolutionsSolutionImages("./screen5.png"), // Dynamically load the image
  // ];

  // updating height to modify sidebar height
  useEffect(() => {
    const updateSize = () => {
      const { height } =
        CheckECommerceSolutionsSize.current.getBoundingClientRect();
      setPagesWidthHeight((prev) => ({
        ...prev,
        height: parseFloat(height.toFixed(1)),
      }));
      // console.log("Heigth", height);
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []);

  // Fetch Likes From Database
  useEffect(() => {
    const AllViews = async () => {
      const hasViewed = localStorage.getItem(`viewed_${questionId}`); // Check if user has already viewed this question

      try {
        if (hasViewed) {
          // alert("You have already Viewed this question.");
          // Fetching the current view data
          const ViewsResponse = await axios.get(
            `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
          );
          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            // alert('Thank you for Viewing the question!');
          } else {
            console.error("No view data received from the get req and server");
          }
        } else {
          // Sending PUT request to the server to update or create the view count
          const ViewsResponse = await axios.put(
            `https://affiliators.netlify.app/.netlify/functions/server/api/views/${questionId}`
          );

          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            localStorage.setItem(`viewed_${questionId}`, "true"); // Mark as viewed in localStorage
            // alert("Thank you for Viewing the question!");
          } else {
            console.error("No view data received from the put req and server");
          }
        }
      } catch (error) {
        console.error("Error updating views:", error.message);

        // Check if the error is due to the document not being found
        if (error.response && error.response.status === 404 && !hasViewed) {
          // Retry by invoking GET request to create the data if missing
          try {
            // Retry the GET request only if the user has not viewed yet
            const retryResponse = await axios.get(
              `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
            );
            if (retryResponse.data && retryResponse.data.views !== undefined) {
              setViews(retryResponse.data.views); // Update state with the number of views
              // alert("Thank you for Viewing the question!");
            } else {
              console.error("No view data received from the retry GET request");
            }
          } catch (retryError) {
            console.error("Error on retrying GET request:", retryError.message);
            // alert("Error retrying to fetch view data. Please try again later.");
          }
        } else {
          // alert("Error updating views. Please try again later.");
        }
      }
    };

    AllViews();

    const fetchOrAddLikes = async () => {
      try {
        const fetchresponse = await axios.get(
          `https://affiliators.netlify.app/.netlify/functions/server/api/checklikes/${questionId}`
        ); // Fetch or create likes
        setLikes(fetchresponse.data.likes); // Update state with the number of likes
      } catch (error) {
        console.error("Error fetching or adding likes:", error.message);
      }
    };

    fetchOrAddLikes();
  }, []);

  const HandleLike = async () => {
    const hasLiked = localStorage.getItem(`liked_${questionId}`); // Check if user has liked the question

    if (hasLiked) {
      // alert("You have already liked this question.");
      return;
    }
    try {
      const response = await axios.put(
        `https://affiliators.netlify.app/.netlify/functions/server/api/updatelikes/${questionId}`
      ); // Send request to backend
      setLikes(response.data.likes); // Update the likes state with the latest count

      // Store in localStorage to prevent multiple likes
      localStorage.setItem(`liked_${questionId}`, "true");
      // alert("Thank you for liking the question!");
    } catch (error) {
      console.error("Error updating likes:", error.message);
    }
  };

  const SidebarProps = {
    RTL1: "https://www.nexcess.net/blog/checkout-problems/",
    RTL2: "https://cloudinary.com/guides/web-performance/website-speed-5-reasons-your-site-is-slow-and-how-to-fix-it",
    RTL3: "https://www.netsuite.com/portal/resource/articles/inventory-management/inventory-management-challenges.shtml",
    RTL4: "https://technologyadvice.com/blog/sales/payment-security/",
    RTL5: "https://devrev.ai/blog/common-customer-support-challenges",
    RTL6: "https://verpex.com/blog/ecommerce-woocommerce-hosting/10-ways-to-optimize-your-ecommerce-website-for-mobile",
    RTC1: "Poor Checkout Process",
    RTC2: "Slow Website Speed",
    RTC3: "Inventory Management Issues",
    RTC4: "Payment Security Concerns",
    RTC5: "Customer Support Challenges",
    RTC6: "Mobile Shopping Optimization",
  };

  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Common E-Commerce Challenges Solutions 🛒</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover the most common e-commerce challenges and learn practical strategies to overcome them for better business success."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="e-commerce challenges, online business problems, e-commerce solutions, e-commerce growth"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Common E-Commerce Challenges Solutions 🛒"
        />
        <meta
          property="og:description"
          content="Discover the most common e-commerce challenges and learn practical strategies to overcome them for better business success."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/problemsolving/ecommercesolutions"
        />
        {/* <meta
          property="og:image"
          content="/images/ECommerceSolutions/ecommercesolutions1.png"
        /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Common E-Commerce Challenges Solutions 🛒"
        />
        <meta
          name="twitter:description"
          content="Discover the most common e-commerce challenges and learn practical strategies to overcome them for better business success."
        />
        {/* <meta
          name="twitter:image"
          content="/images/ECommerceSolutions/ecommercesolutions1.png"
        /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/problemsolving/ecommercesolutions"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div className={Styles.BlogSidebarECommerceSolutionsContainer}>
        <Sidebar {...SidebarProps} />
        <div
          ref={CheckECommerceSolutionsSize}
          className={Styles.ECommerceSolutionsContainer}
        >
          <section className={Styles.ECommerceSolutionsSection1Container}>
            <div
              className={
                Styles.ECommerceSolutionsSection1QuestionLikesViewsContainer
              }
            >
              <h4>Problem</h4>
              <h1>Common E-Commerce Challenges.</h1>
              <div
                className={Styles.ECommerceSolutionsSection1LikesViewsContainer}
              >
                <button
                  className={Styles.LikeButton}
                  onClick={HandleLike}
                  aria-label="Like this question"
                >
                  👍🏻 {likes}
                </button>
                <span>{Views} Views</span>
              </div>
            </div>
          </section>
          <section className={Styles.ECommerceSolutionsSection2Container}>
            <div className={Styles.ECommerceSolutionsSection2AnswerContainer}>
              <h4>Solution</h4>
              <p>Follow These Steps:</p>
              <h3>Step No. 1 ....</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.ECommerceSolutionsSection2AnswerVideo1}
                src="https://www.youtube.com/embed/Mn-B16MZP7U?si=AnadAqFu0Y-LNmSy"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <p>
                If the following video solved your problem, feel free to skip
                the remaining steps. If not, continue with the next steps ⬇️
              </p>
              <h3>Step 2: Choose the Right E-Commerce Platform</h3>
              {/* <h3>For Windows Users</h3> */}
              <div
                className={
                  Styles.ECommerceSolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Opt for scalable solutions like Shopify, WooCommerce, or
                    Magento.
                  </p>
                  {/* <img src={SolutionImages[0]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Ensure the platform supports secure payment gateways.
                  </p>
                  {/* <img src={SolutionImages[2]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Look for easy integration with third-party tools and
                    apps.
                  </p>
                  {/* <img src={SolutionImages[1]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 3: Optimize Website Performance</h3>
              <div
                className={
                  Styles.ECommerceSolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>👉🏻 Use a fast hosting service with high uptime.</p>

                  <p>
                    👉🏻 Optimize images and enable browser caching for speed.
                  </p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Implement CDN (Content Delivery Network) to improve load
                    times.
                  </p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 4: Secure & Simplify Checkout Process</h3>
              <div
                className={
                  Styles.ECommerceSolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>👉🏻 Offer multiple payment methods for user convenience.</p>

                  <p>👉🏻 Use a one-page checkout to reduce friction.</p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>👉🏻 Implement auto-fill options for faster transactions.</p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 5: Mobile Optimization for More Sales</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.ECommerceSolutionsSection2AnswerVideo1}
                src="https://www.youtube.com/embed/sObU5W7qbTs?si=kgYSV1l1H6D8LuEl"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <div
                className={
                  Styles.ECommerceSolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Ensure a mobile-responsive design for seamless browsing.
                  </p>

                  <p>
                    👉🏻 Implement fast-loading pages with AMP (Accelerated Mobile
                    Pages).
                  </p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Optimize buttons and forms for touch-friendly navigation.
                  </p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 6: Leverage SEO & Marketing Strategies</h3>
              <div
                className={
                  Styles.ECommerceSolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Use high-ranking keywords to improve search visibility.
                  </p>

                  <p>👉🏻 Implement social media & email marketing campaigns.</p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.ECommerceSolutionsSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Optimize product pages with clear descriptions & reviews.
                  </p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <p>
                I hope you found this helpful! 👍✨ Don't forget to rate this
                blog!
              </p>
              <h3>HashTags</h3>
              <p>
                #ECommerce #OnlineStore #SEO #WebOptimization #UXDesign
                #FastCheckout #MobileFriendly #DigitalMarketing #SecurePayments
                #BoostSales
              </p>
              <h3>Keywords</h3>
              <p>
                e-commerce solutions, best e-commerce platforms, optimize online
                store, secure payment methods, improve website speed,
                mobile-friendly e-commerce, SEO for e-commerce, best checkout
                process, boost online sales, grow e-commerce business.
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ECommerceSolutions;
